import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(23 * 3600 + 53 * 60 + 20);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'hrs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-ink text-white" data-id="element-32" data-mp="anji4cozlmpw">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.14em] sm:text-xs" data-id="element-33" data-mp="6mpt1fzt61vf">
        <HourglassIcon className="h-3.5 w-3.5 text-lime" aria-hidden="true" data-id="element-34" data-mp="13cpic4ljsqf0" />
        <span className="text-white/80" data-id="element-35" data-mp="18dwpc1fv9lkm">Launch offer ends in:</span>
        <span className="flex items-center gap-1 font-display tabular-nums" aria-live="off" data-id="element-36" data-mp="uduako2uv89l">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-37" data-mp="ygr06yqtc4n1" data-mpi={index}>
              <span className="text-base font-bold text-lime sm:text-lg" data-id="element-38" data-mp="1m51tngu6j21a">
                {pad(unit.value)}
              </span>
              <span className="text-[9px] tracking-normal text-white/60" data-id="element-39" data-mp="1r5fr64y5mtl2">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="px-0.5 text-white/30" data-id="element-40" data-mp="1hc8m6l7btfli">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}